import React from 'react'

import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function Profile() {
	return (
		<Paper style={{ padding: 20, minHeight:800 }} >
			<Text variant='h5' gutterBottom>
				Profile
			</Text>
			<Text variant='caption' gutterBottom>
				Profile
			</Text>
		</Paper>
	)
}
export default Profile
